import { createSlice } from '@reduxjs/toolkit';
import { TDevice } from '@cian/utils';

import { IParsedQsParams } from '../types/qsParams';
import { IIntroValues } from '../types/redux/intro';
import { TAbUseExperiments } from '../types/abUseExperiments';
import { GetReturnType } from '../types/getReturnType';

export interface IPageState {
  deviceType: TDevice;
  referrer: string;
  queryParams: IParsedQsParams;
  /** Поле берется из куки _CIAN_WEBVIEW_PLATFORM и определяет платформу, если юзер находится в режиме webview */
  platform: string | null;
  isWebview: boolean;
  intro: IIntroValues;
  abUseExperiments: TAbUseExperiments;
}

export const pageInitialState: IPageState = {
  deviceType: 'desktop' as const,
  referrer: '',
  queryParams: {},
  platform: 'desktop',
  isWebview: false,
  intro: {
    fromSaleRent: false,
    fromN1: false,
    fromBankiru: false,
    fromAlfaBank: false,
    transactionId: null,
  },
  abUseExperiments: [],
};

// Данные страницы
export const pageSlice = createSlice({
  name: 'page',
  initialState: pageInitialState,
  reducers: {},
});

export type TPageSlice = GetReturnType<typeof pageSlice.actions>;
